import { useCallback } from "react";
import { MdModeEdit } from "react-icons/md";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import Swal from "sweetalert2";
import { editProfile, editProfileStatus } from "../../../redux/users/userSlice";
import Loading from "../../../Components/Common/Loading";
import Cookies from "js-cookie";
import CopyEmail from "../../../Components/Common/CopyEmail";
const formatDate = (date) => format(new Date(date), "dd MMM, yyyy");
const formatTime = (date) => format(new Date(date), "hh:mm a");

// A practitioner can belong to several hospitals; only this hospital's membership is shown and toggled here.
const isCurrentPractitioner = (tenant) =>
  tenant.userType === "practitioner" && String(tenant.tenantId) === String(Cookies.get("TenantId"));

const UserTd = ({ toggleCreateProviderForm }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { users, getProfilesStatus } = useSelector((state) => state.users);

  const formatDate = (data) => format(new Date(data), "dd MMM, yyyy");

  const handleToggle = async (id, event,newStatus) => {
    event.stopPropagation();
    const user = users.find((user) => user._id === id);
    if (!user) return;
    // const tenantId =  Cookies.get("TenantId")
    // const newStatus = !user.tenants.find((tenant) => tenant.tenantId === tenantId && userType === "provider").status;
    //for changes

    const result = await Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${
        newStatus ? "activate" : "deactivate"
      } this Practitioner?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#1769d1",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${newStatus ? "activate" : "deactivate"} it!`,
    });

    if (result.isConfirmed) {
      try {
        await dispatch(
          editProfileStatus({
            body: { status: newStatus },
            id: user._id,
            userId: user.userId,
          })
        ).unwrap();
      } catch (message) {
        Swal.fire({ title: "Update failed", text: String(message), icon: "error", confirmButtonColor: "#1769d1" });
        return;
      }

      Swal.fire({
        title: "Updated!",
        text: `User has been ${
          newStatus ? "activated" : "deactivated"
        } successfully.`,
        icon: "success",
        confirmButtonColor: "#1769d1",
      });
    }
  };

  const handleEditClick = (id, event) => {
    event.stopPropagation();
    navigate(`/iam/users?ProId=${id}`);
    toggleCreateProviderForm();
 
  };

  return (
    <>
      {users?.length > 0 &&
        users.map((user) => (
          <tr
            key={user._id}
            className="hover:bg-gray-100 bg-gray-50 border border-gray-300 hover:shadow-lg transition duration-300 ease-in-out cursor-pointer"
          >
            <td className="py-4 px-6 font-medium">
              {`${user.firstName} ${user.lastName}`}
              <div className="text-xs text-gray-600 mt-1">
                <div>Gender: {user.gender}</div>
                <div>Number: {user.phoneNumber.value}</div>
              </div>
            </td>

            <td className="py-4 px-6"><CopyEmail email={user.email} /></td>

            <td className="py-4 px-6 text-sm text-brand-700 font-semibold text-left">
              {user.work?.speciality || "N/A"}
              <br />
              {user.work?.experience
                ? `${Math.floor(user.work.experience / 12)} Years ${
                    user.work.experience % 12
                      ? `${user.work.experience % 12} Months`
                      : ""
                  }`
                : "N/A"}
            </td>

            {user.tenants.filter(isCurrentPractitioner).map(
              (tenant) => (
                  <td key={tenant.tenantId} className="py-4 px-6 text-sm text-brand-700 font-semibold">
                    <span
                      className={`inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold ${
                        tenant.status
                          ? "bg-green-100 text-green-900"
                          : "bg-blue-100 text-blue-900"
                      }`}
                    >
                      {tenant.status ? "Active" : "Pending"}
                    </span>
                  </td>
                )
            )}
        

            <td className="py-4 px-6 text-sm text-brand-700 font-semibold text-left">
              {formatDate(user.createdAt)}
              <br />
              {formatTime(user.createdAt)}
            </td>

            <td className="py-4 px-6 text-sm text-brand-700 font-semibold text-left">
              {formatDate(user.updatedAt)}
              <br />
              {formatTime(user.updatedAt)}
            </td>

            <td className="flex flex-flow-col gap-6 text-xl text-brand-500 py-5 px-7 text-[13px]">
              <div
                className="hover:bg-gray-300 rounded-full p-2"
                onClick={(event) => handleEditClick(user._id, event)}
              >
                <MdModeEdit />
              </div>
 
            </td>
            {user.tenants.filter(isCurrentPractitioner).map(
              (tenant) => (
                  <td key={tenant.tenantId}>
                    <label
                      htmlFor={`toggle-${user._id}`}
                      className="flex items-center gap-2 w-[60%] cursor-pointer"
                    >
                      <input
                        type="checkbox"
                        id={`toggle-${user._id}`}
                        checked={tenant.status}
                        onChange={(event) => handleToggle(user._id, event, !tenant.status)}
                        className="sr-only"
                      />
                      <div
                        className={`w-10 h-6 flex items-center rounded-full p-1 transition duration-300 ease-in-out ${
                          tenant.status ? "bg-brand-500" : "bg-gray-300"
                        }`}
                      >
                        <div
                          className={`w-4 h-4 bg-white rounded-full shadow-md transform transition duration-300 ease-in-out ${
                            tenant.status ? "translate-x-4" : "translate-x-0"
                          }`}
                        ></div>
                      </div>
                    </label>
                  </td>
                )
            )}
          </tr>
        ))}
    </>
  );
};

export default UserTd;
